import BackButton from "../../../../parts/BackButton";
import SvgIcon from "../../../../parts/SvgIcon";

const IncomeHeader = ({ context, currency = "usd", connectedAccountId, t }) => (
  <div className="income-header">
    <div className="income-header__title-group">
      <BackButton />
      <div>
        <h1>
          {t("income.header.title", {
            context: t(`income.context.${context}`),
          })}
        </h1>
        <p>
          {t(`income.header.subtitle.${context}`, {
            currency: currency.toUpperCase(),
          })}
        </p>
      </div>
    </div>
    {connectedAccountId && (
      <a
        href={`https://dashboard.stripe.com/${connectedAccountId}`}
        target="_blank"
        rel="noreferrer"
        data-button-type="primary"
        className="flex items-center gap-2"
        role="button"
        data-icon
        sz="large"
      >
        {t("income.header.stripeDashboard")}
        <SvgIcon src="/img/new-icons/export.svg" noFilterOnLight />
      </a>
    )}
  </div>
);

export default IncomeHeader;
